// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ce_a bhg_h bhg_kf bhg_wb bhg_ss bhg_vr bhg_su bhg_sl"};